var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/well-known-symbol-wrapped.js
// module id = mRdL
// module chunks = 0